import { FC } from 'react';

import { ButtonProps, ButtonVariant } from '@/shared/ui/Button';
import { Button } from '@/shared/ui/Button/Button';
import { Icon } from '@/shared/ui/Icon/Icon';

export const DeletePermitButton: FC<ButtonProps> = (props) => {
  return (
    <Button data-testid="delete-permit-button" variant={ButtonVariant.GHOST_WARNING} {...props}>
      <Icon name="close" />
      Завершити
    </Button>
  );
};
